export default "__VITE_ASSET__DJ$c5pcl__"